import { Moment } from 'moment'
import React, { FunctionComponent } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface IProps {
  selectedPersonUuid: string
  appointmentMoment: Moment
}

export const LastMinutesForm: FunctionComponent<IProps> = (
  {
    // selectedPersonUuid,
    // appointmentMoment,
  },
) => {
  const { t } = useTranslation()
  const { handleSubmit, setValue } = useForm()
  const onSubmit = (data: any) => console.log(data)

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {/*            <AppointmentDateRangePicker
                inputName="startsAt"
                setValue={setValue}
                appointmentMoment={appointmentMoment}
            />
            <HourPicker
                setValue={setValue}
                inputName="selectedHour"
                appointmentMoment={appointmentMoment}
            />
            <UpdateTextArea fieldName="notes" setValue={setValue} label={t('Last minute description')} />
            <AppointmentActivity
                selectedPersonUuid={selectedPersonUuid}
                setValue={setValue}
            /> */}
      <LabelTextArea
        fieldLabel={t('Last minute note')}
        fieldColor="#005cd9"
        onChange={e => setValue('description', e.target.value)}
        customWidth="400px"
      />
    </form>
  )
}
